import { render, staticRenderFns } from "./goods-select.vue?vue&type=template&id=392979d0&scoped=true&"
import script from "./goods-select.vue?vue&type=script&lang=js&"
export * from "./goods-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392979d0",
  null
  
)

export default component.exports